// `${process.env.REACT_APP_API_BASE_URL}/invest/token:getList`
export const getTokensListUrl = `${process.env.REACT_APP_API_BASE_URL}/invest/token:getList`;
